export default "__VITE_ASSET__32da71ec__"